import { ReactNode, useRef } from 'react';
import { FormInstance, Input, ModalProps } from 'antd';
import { useTranslation } from 'react-i18next';
import SModalForm from '@/styles/SModalForm';
import { DictInfo } from '@/types/dict';

interface SDictFormProps extends ModalProps {
	onlyText: boolean;
	handleCancel: () => void;
	handleOk: (data: DictInfo) => Promise<void>;
	data: DictInfo | null;
	leftTitle: ReactNode;
	confirmLoading: boolean;
}

const DictForm = (props: SDictFormProps) => {
	const { t } = useTranslation();
	const formRef = useRef<FormInstance<DictInfo>>(null);

	return (
		<SModalForm<DictInfo>
			modelFormRef={formRef}
			formItems={[
				props.onlyText ? undefined as any : {
					label: t('components.dictName'),
					name: 'key',
					children: <Input placeholder={t('components.plDictName')} maxLength={100} showCount />,
					required: true,
					rules: [{ required: true, message: t('components.plDictName') }],
				},
				{
					label: t('components.dictDesc'),
					name: 'desc',
					children: <Input.TextArea autoSize={{ maxRows: 6, minRows: 6 }} placeholder={t('components.plContent')} maxLength={200} showCount />,
					required: true,
					rules: [{ required: true, message: t('components.plContent') }],
					style: props.onlyText ? { marginTop: -40 } : undefined
				},
			]}
			{...props}
		/>
	);
};

export default DictForm;
